import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getTime } from 'date-fns';
import { Body_4 as Body4 } from '@huggg/react-components'

import unixToDHM from 'utilities/unixToDHM';

const Countdown = props => {
  const {
    onExpiry,
    showDays,
    showHours,
    showMinutes,
    showSeconds,
    showSuffix,
    start,
    end,
    ...rest
  } = props;

  const [time, setTime] = useState(
    Math.floor((getTime(end) - getTime(start)) / 1000) * 1000
  );

  const dhm = unixToDHM(time);
  const pluralise = (time, string) => {
    return string + (time === '0' || time > 1 ? 's' : '');
  };

  const formatted = Object.keys(dhm).map(key => {
    if (!props['show' + key.charAt(0).toUpperCase() + key.slice(1)]) {
      return '';
    }

    const singularName = key.slice(0, key.length - 1);
    let built = dhm[key];

    built += showSuffix ? ' ' + pluralise(dhm[key], singularName) : '';

    return built;
  });

  useEffect(() => {
    let timeout = null;

    if (time > 0) {
      timeout = setTimeout(() => {
        setTime(time - 1000);
      }, 1000);
    } else {
      onExpiry && onExpiry();
    }

    return function cleanup() {
      clearTimeout(timeout);
      timeout = null;
    };
  });

  return (
    <span data-test-id="countdown" {...rest}>
      <Body4 style={{ display: 'inline' }}>
        {formatted
          .filter(_ => _) // Filter out empty strings
          .join(' ')}
      </Body4>
    </span>
  );
};

Countdown.defaultProps = {
  showDays: true,
  showHours: true,
  showMinutes: true,
  showSeconds: true,
  showSuffix: true,
  start: Date.now(),
  end: Date.now() + 10000
};

Countdown.propTypes = {
  end: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  onExpiry: PropTypes.func,
  showDays: PropTypes.bool,
  showHours: PropTypes.bool,
  showMinutes: PropTypes.bool,
  showSeconds: PropTypes.bool,
  showSuffix: PropTypes.bool,
  start: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)])
};

export default Countdown;
